(() => {
  const selector = '[data-cil-colour-group]';
  const normalise = value => String(value || '').trim().toLocaleLowerCase('en-GB');
  let catalogue;
  let pending;
  let scheduled = false;
  const handled = new WeakSet();
  async function loadCatalogue(base) {
    const groups = new Map();
    let page = 1;
    const visited = new Set();
    while (page && !visited.has(page)) {
      visited.add(page);
      const url = new URL(base, location.origin);
      url.searchParams.set('section_id', 'cil-colour-index');
      url.searchParams.set('page', String(page));
      const response = await fetch(url, { credentials: 'same-origin' });
      if (!response.ok) throw new Error('Colour index unavailable');
      const documentFragment = new DOMParser().parseFromString(await response.text(), 'text/html');
      const index = documentFragment.querySelector('[data-cil-colour-index]');
      if (!index) throw new Error('Colour index missing');
      for (const link of index.querySelectorAll('a[data-group]')) {
        const group = normalise(link.dataset.group);
        if (!groups.has(group)) groups.set(group, []);
        groups.get(group).push({
          id: link.dataset.id,
          colour: link.dataset.colour,
          image: link.dataset.image,
          url: link.getAttribute('href')
        });
      }
      page = Number(index.dataset.nextPage) || 0;
    }
    return groups;
  }
  function render(box, groups) {
    const group = normalise(box.dataset.cilColourGroup);
    const products = groups.get(group);
    if (!group || !products || handled.has(box)) return;
    const target = box.querySelector('.option__colors');
    if (!target) return;
    const selected = box.dataset.cilProductId;
    const colours = new Map();
    for (const product of products) {
      const key = normalise(product.colour);
      if (!colours.has(key) || product.id === selected) colours.set(key, product);
    }
    if (![...colours.values()].some(product => product.id === selected)) return;
    const fragment = document.createDocumentFragment();
    for (const product of colours.values()) {
      const link = document.createElement('a');
      link.className = 'color';
      link.href = product.url;
      link.title = product.colour;
      link.setAttribute('aria-label', product.colour);
      if (product.id === selected) {
        link.classList.add('is-active');
        link.setAttribute('aria-current', 'page');
      }
      const image = document.createElement('img');
      image.src = product.image;
      image.alt = product.colour;
      image.title = product.colour;
      image.width = 100;
      image.height = 100;
      image.style.cssText = 'width:100%;height:100%;object-fit:cover;display:block';
      link.append(image);
      fragment.append(link);
    }
    handled.add(box);
    target.replaceChildren(fragment);
  }
  async function refresh() {
    const boxes = [...document.querySelectorAll(selector)];
    if (!boxes.length) return;
    try {
      if (!pending) pending = loadCatalogue(boxes[0].dataset.cilIndexUrl);
      catalogue = await pending;
      boxes.forEach(box => render(box, catalogue));
    } catch {
      pending = null;
    }
  }
  function schedule() {
    if (scheduled) return;
    scheduled = true;
    requestAnimationFrame(() => { scheduled = false; refresh(); });
  }
  const observer = new MutationObserver(records => {
    if (records.some(record => [...record.addedNodes].some(node =>
      node.nodeType === 1 && (node.matches(selector) || node.querySelector(selector))))) schedule();
  });
  observer.observe(document.body, { childList: true, subtree: true });
  document.addEventListener('shopify:section:load', schedule);
  refresh();
})();

